import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { router } from '../../router'
import { getRandomString } from '../../lib'

export const useAppStateStore = defineStore('app-state', () => {
  const isLoading = ref(false)
  const isUniqueLoading = ref(false)
  const loadingPercent = ref(0)
  // 로딩 중 스피너 아래에 표시할 안내 문구
  const loadingMessage = ref('')
  const uniqLoadingId = ref<string | null>(null)

  // 강제 로딩 제어용 내부 상태
  let loadingIdCounter = 0
  const lockedLoadingId = ref<number | null>(null)

  /**
   * 로딩 상태 설정
   * @param value - 로딩 표시 여부
   * @param message - 스피너 아래에 표시할 안내 문구 (해제 시 자동 초기화)
   */
  function setIsLoading(value: boolean, message = ''): void {
    if (lockedLoadingId.value === null) {
      isLoading.value = value
      loadingMessage.value = value ? message : ''
    }
  }
  function setLoadingPercent(value: number): void {
    loadingPercent.value = value
  }

  // 강제 로딩 - 다른 로딩을 막고 고유 ID 반환
  function forceLoadingShow(): number {
    loadingIdCounter += 1
    const id = loadingIdCounter
    lockedLoadingId.value = id
    isLoading.value = true
    return id
  }

  // 강제 로딩 해제 - ID가 일치할 때만 해제
  function forceLoadingClose(id: number): void {
    if (lockedLoadingId.value === id) {
      isLoading.value = false
      lockedLoadingId.value = null
    }
  }

  function uniqueLoadingShow(): string {
    const uniqueLoadingId = getRandomString(10, false)
    uniqLoadingId.value = uniqueLoadingId
    isUniqueLoading.value = true
    return uniqueLoadingId
  }
  // ID 불일치 시 무시
  function uniqueLoadingClose(loadingId: string): void {
    if (uniqLoadingId.value === loadingId) {
      isUniqueLoading.value = false
      uniqLoadingId.value = null
    }
  }

  const isHiddenHeader = computed(() => {
    const route = router.currentRoute
    const { path } = route.value
    // 품질점검 점검 화면은 자체 상단바 사용 (관리 화면 /quality/manage/* 는 헤더 표시)
    if (path.startsWith('/quality/task')) return true
    if (path.startsWith('/quality')) return false
    if (path.includes('/task')) return true
    if (path.includes('/login')) return true
    if (path.includes('/demo')) return true
    if (path.includes('/public')) return true
    return false
  })

  return {
    isLoading,
    loadingPercent,
    loadingMessage,
    setIsLoading,
    setLoadingPercent,
    forceLoadingShow,
    forceLoadingClose,
    isHiddenHeader,
    isUniqueLoading,
    uniqLoadingId,
    uniqueLoadingShow,
    uniqueLoadingClose,
  }
})
